<nav class="top-bar">

  <span class="menu-title">{{currentTitle | translate}}</span>
  <button class=" close-burger" *ngIf="isOpen" (click)="closeMenu() ">
    <span class="icon-menu">
      <img src="assets/icons/mobile-menu/ico_menu_arrow-color.svg" />
    </span>
  </button>
  <button class="burger" (click)="toggleMenu()">
    &#9776;
  </button>
</nav>

<div class="overlay" *ngIf="isOpen" (click)="toggleMenu()"></div>

<div class="menu-panel" *ngIf="isOpen">
  <ul>
    <!-- <li class="manu-item" (click)="closeMenu()" [routerLinkActive]="['active']" [routerLink]="['/dashboard']"
      *ngIf="usersService.InterfaceIsPermitted(interfacePermissions.ANALYTICS)">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico_menu_monitor.svg" />
      </span>
      <span class="label">{{ 'Analytics' | translate }}</span>
      <span class="chevron">›</span>
    </li> -->
    <li class="manu-item" (click)="closeMenu()" [routerLinkActive]="['active']" [routerLink]="['/']"
      *ngIf="usersService.InterfaceIsPermitted(interfacePermissions.TRACKING)">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico_menu_tracks.svg" />
      </span>
      <span class="label">{{ 'Tracking' | translate }}</span>
      <span class="chevron">›</span>
    </li>
    <li class="manu-item" (click)="closeMenu()" [routerLinkActive]="['active']" [routerLink]="['/reports']"
      *ngIf="usersService.InterfaceIsPermitted(interfacePermissions.REPORTS)">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico_menu_report.svg" />
      </span>
      <span class="label">{{ 'Reports' | translate }}</span>
      <span class="chevron">›</span>
    </li>
    <!-- <li class="manu-item" (click)="closeMenu()" [routerLinkActive]="['active']">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico_menu_notifications.svg" />
      </span>
      <span class="label">{{ 'Notifications' | translate }}</span>
      <span class="chevron">›</span>
    </li> -->
    <li class="manu-item" (click)="closeMenu()" [routerLinkActive]="['active']" [routerLink]="['/geozones']">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico_menu_geozone.svg" />
      </span>
      <span class="label">{{ 'Geozones' | translate }}</span>
      <span class="chevron">›</span>
    </li>
    <!-- <li class="manu-item" (click)="closeMenu()" [routerLinkActive]="['active']" [routerLink]="['/history']"
        *ngIf="usersService.InterfaceIsPermitted(interfacePermissions.HISTORY)">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico-menu_history.svg" />
      </span>
      <span class="label">{{ 'History' | translate }}</span>
      <span class="chevron">›</span>
    </li> -->
    <li class="manu-item" (click)="closeMenu()" [routerLinkActive]="['active']" [routerLink]="['/settings']">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico_menu_settings.svg" />
      </span>
      <span class="label">{{ 'Settings' | translate }}</span>
      <span class="chevron">›</span>
    </li>
    <li class="manu-item" (click)="logout()">
      <span class="icon-menu">
        <img src="assets/icons/mobile-menu/ico-menu_logout.svg" />
      </span>
      <span class="label label-flex">{{ 'Logout' | translate }} <span *ngIf="user" class="userName">({{ user.Name
          }})</span></span>
      <span class="chevron">›</span>
    </li>
  </ul>


</div>

<ng-container *ngIf="profile; else loading">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #loading>
  <div class="flex flex-column justify-content-center align-items-center h-full">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>


<!-- <template #navUsersDialog></template> -->